import api from "api/api";

// Fast & Furious — categories/roles reference data (settings service).
// Flat table since redmine 12940: one row per job category. The two-level taxonomy
// (root = category, child = job) is gone — jobs live in `settings_jobs`.
export const getCategoriesQuery = async () =>
  await api.get(`/settings/category`);
